import React from 'react';
let footerDiv = {
    position: 'fixed',
    bottom: '0',
    width: '100%',
    backgroundColor: '#00A1E4',
    color: '#ffffff'
}

function Footer() {
    return (
        <div style={footerDiv}>
            <div className="divContentCenter" style={{ fontSize: '12px' }}>Copyright &copy; 2024 ZenEremit. All rights reserved.</div>
        </div>
    );
}
export default Footer;